import {
  LIST_DISCURSIVE_ASSESSMENTS_REQUEST,
  LIST_DISCURSIVE_ASSESSMENTS_SUCCESS,
  LIST_DISCURSIVE_ASSESSMENTS_ERROR,
  GET_DISCURSIVE_ASSESSMENT_REQUEST,
  GET_DISCURSIVE_ASSESSMENT_SUCCESS,
  GET_DISCURSIVE_ASSESSMENT_ERROR,
  ADD_DISCURSIVE_ASSESSMENT_REQUEST,
  ADD_DISCURSIVE_ASSESSMENT_SUCCESS,
  ADD_DISCURSIVE_ASSESSMENT_ERROR,
  EDIT_DISCURSIVE_ASSESSMENT_REQUEST,
  EDIT_DISCURSIVE_ASSESSMENT_SUCCESS,
  EDIT_DISCURSIVE_ASSESSMENT_ERROR,
  EDIT_ACTIVE_DISCURSIVE_ASSESSMENT_REQUEST,
  EDIT_ACTIVE_DISCURSIVE_ASSESSMENT_SUCCESS,
  EDIT_ACTIVE_DISCURSIVE_ASSESSMENT_ERROR,
  LIST_DISCURSIVE_ASSESSMENT_SUBJECTS_REQUEST,
  LIST_DISCURSIVE_ASSESSMENT_SUBJECTS_SUCCESS,
  LIST_DISCURSIVE_ASSESSMENT_SUBJECTS_ERROR,
  LIST_DISCURSIVE_QUESTION_FIELDS_REQUEST,
  LIST_DISCURSIVE_QUESTION_FIELDS_SUCCESS,
  LIST_DISCURSIVE_QUESTION_FIELDS_ERROR,
  VINCULATE_DISCURSIVE_ASSESSMENT_SUBJECTS_REQUEST,
  VINCULATE_DISCURSIVE_ASSESSMENT_SUBJECTS_SUCCESS,
  VINCULATE_DISCURSIVE_ASSESSMENT_SUBJECTS_ERROR,
  VINCULATE_DISCURSIVE_ASSESSMENT_QUESTIONS_REQUEST,
  VINCULATE_DISCURSIVE_ASSESSMENT_QUESTIONS_SUCCESS,
  VINCULATE_DISCURSIVE_ASSESSMENT_QUESTIONS_ERROR,
  SEND_DISCURSIVE_ASSESSMENT_REQUEST,
  SEND_DISCURSIVE_ASSESSMENT_SUCCESS,
  SEND_DISCURSIVE_ASSESSMENT_ERROR,
} from '../actions';

export const listDiscursiveAssessmentsRequest = () => ({
  type: LIST_DISCURSIVE_ASSESSMENTS_REQUEST,
});
export const listDiscursiveAssessmentsSuccess = (discursiveAssessments) => ({
  type: LIST_DISCURSIVE_ASSESSMENTS_SUCCESS,
  payload: discursiveAssessments,
});
export const listDiscursiveAssessmentsError = (message) => ({
  type: LIST_DISCURSIVE_ASSESSMENTS_ERROR,
  payload: { message },
});

export const getDiscursiveAssessmentRequest = (id) => ({
  type: GET_DISCURSIVE_ASSESSMENT_REQUEST,
  payload: { id },
});
export const getDiscursiveAssessmentSuccess = (discursiveAssessment) => ({
  type: GET_DISCURSIVE_ASSESSMENT_SUCCESS,
  payload: discursiveAssessment,
});
export const getDiscursiveAssessmentError = (message) => ({
  type: GET_DISCURSIVE_ASSESSMENT_ERROR,
  payload: { message },
});

export const addDiscursiveAssessmentRequest = (discursiveAssessment) => ({
  type: ADD_DISCURSIVE_ASSESSMENT_REQUEST,
  payload: { discursiveAssessment },
});
export const addDiscursiveAssessmentSuccess = (discursiveAssessment) => ({
  type: ADD_DISCURSIVE_ASSESSMENT_SUCCESS,
  payload: discursiveAssessment,
});
export const addDiscursiveAssessmentError = (message) => ({
  type: ADD_DISCURSIVE_ASSESSMENT_ERROR,
  payload: { message },
});

export const editDiscursiveAssessmentRequest = (discursiveAssessment) => ({
  type: EDIT_DISCURSIVE_ASSESSMENT_REQUEST,
  payload: { discursiveAssessment },
});
export const editDiscursiveAssessmentSuccess = (discursiveAssessment) => ({
  type: EDIT_DISCURSIVE_ASSESSMENT_SUCCESS,
  payload: { discursiveAssessment },
});
export const editDiscursiveAssessmentError = (message) => ({
  type: EDIT_DISCURSIVE_ASSESSMENT_ERROR,
  payload: { message },
});

export const editActiveDiscursiveAssessmentRequest = (id, active) => ({
  type: EDIT_ACTIVE_DISCURSIVE_ASSESSMENT_REQUEST,
  payload: { id, active },
});
export const editActiveDiscursiveAssessmentSuccess = (id, active) => ({
  type: EDIT_ACTIVE_DISCURSIVE_ASSESSMENT_SUCCESS,
  payload: { id, active },
});
export const editActiveDiscursiveAssessmentError = (message) => ({
  type: EDIT_ACTIVE_DISCURSIVE_ASSESSMENT_ERROR,
  payload: { message },
});

export const listDiscursiveAssessmentSubjectsRequest = () => ({
  type: LIST_DISCURSIVE_ASSESSMENT_SUBJECTS_REQUEST,
});
export const listDiscursiveAssessmentSubjectsSuccess = (subjects) => ({
  type: LIST_DISCURSIVE_ASSESSMENT_SUBJECTS_SUCCESS,
  payload: subjects,
});
export const listDiscursiveAssessmentSubjectsError = (message) => ({
  type: LIST_DISCURSIVE_ASSESSMENT_SUBJECTS_ERROR,
  payload: { message },
});

export const listDiscursiveQuestionFieldsRequest = () => ({
  type: LIST_DISCURSIVE_QUESTION_FIELDS_REQUEST,
});
export const listDiscursiveQuestionFieldsSuccess = (fields) => ({
  type: LIST_DISCURSIVE_QUESTION_FIELDS_SUCCESS,
  payload: fields,
});
export const listDiscursiveQuestionFieldsError = (message) => ({
  type: LIST_DISCURSIVE_QUESTION_FIELDS_ERROR,
  payload: { message },
});

export const vinculateDiscursiveAssessmentSubjectsRequest = (subjects) => ({
  type: VINCULATE_DISCURSIVE_ASSESSMENT_SUBJECTS_REQUEST,
  payload: { subjects },
});
export const vinculateDiscursiveAssessmentSubjectsSuccess = (subjects) => ({
  type: VINCULATE_DISCURSIVE_ASSESSMENT_SUBJECTS_SUCCESS,
  payload: { subjects },
});
export const vinculateDiscursiveAssessmentSubjectsError = (message) => ({
  type: VINCULATE_DISCURSIVE_ASSESSMENT_SUBJECTS_ERROR,
  payload: { message },
});

export const vinculateDiscursiveAssessmentQuestionsRequest = (
  questions,
  isLastSubject
) => ({
  type: VINCULATE_DISCURSIVE_ASSESSMENT_QUESTIONS_REQUEST,
  payload: { questions, isLastSubject },
});
export const vinculateDiscursiveAssessmentQuestionsSuccess = (
  questions,
  isLastSubject
) => ({
  type: VINCULATE_DISCURSIVE_ASSESSMENT_QUESTIONS_SUCCESS,
  payload: { questions, isLastSubject },
});
export const vinculateDiscursiveAssessmentQuestionsError = (message) => ({
  type: VINCULATE_DISCURSIVE_ASSESSMENT_QUESTIONS_ERROR,
  payload: { message },
});

export const sendDiscursiveAssessmentRequest = (id) => ({
  type: SEND_DISCURSIVE_ASSESSMENT_REQUEST,
  payload: { id },
});
export const sendDiscursiveAssessmentSuccess = (id, sentAt) => ({
  type: SEND_DISCURSIVE_ASSESSMENT_SUCCESS,
  payload: { id, sentAt },
});
export const sendDiscursiveAssessmentError = (message) => ({
  type: SEND_DISCURSIVE_ASSESSMENT_ERROR,
  payload: { message },
});
